<template>
  <div id="tryout-result-status">
    <v-layout style="margin-bottom: 10px; border-bottom: lightgray 1px solid; padding-bottom: 10px;">
      <v-flex xs9>
        <h4>{{data.name}}</h4>
          <div>
            <img src="@/assets/icon/ion_checkmark_ionicons.svg" alt="subject_logo" height="12px">
            <span class="group-description__detail--spacy">{{data.correct}}</span>
            <img src="@/assets/icon/ion_close_round_ionicons.svg" alt="subject_logo" height="12px">
            <span class="group-description__detail--spacy">{{data.wrong}}</span>
            <img src="@/assets/icon/remove_circle_outline_material.svg" alt="subject_logo" height="12px">
            <span class="group-description__detail--spacy">{{data.empty}}</span>
          </div>
          <div>
            <v-icon style="font-size: 16px;">chrome_reader_mode</v-icon>
            <span class="group-description__detail--spacy">Total {{data.item_count}} Soal</span>
            <v-icon style="font-size: 16px;">timer</v-icon>
            <span class="group-description__detail--spacy">{{data.completion}}</span>
          </div>
      </v-flex>
      <v-flex xs3 style="display:flex; justify-content: flex-end;">
        <v-icon>keyboard_arrow_right</v-icon>
      </v-flex>
     </v-layout>
     <v-dialog v-model="dialog" max-width="350">
      <v-card>
        <v-container fluid grid-list-lg text-xs-center>
          <v-layout row wrap>
            <v-flex xs8 offset-xs2>
              <img src="@/assets/icon/ic_closedfeature.svg" alt="ic_closedfeature">
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12>
              <h3 style="color: #355eab; text-transform: uppercase">Akses Pembahasan Ditutup</h3>
              <p style="margin-top: 15px">Akses untuk melihat pembahasan soal baru akan dibuka pada:</p>
              <!-- <p style="margin-top: 15px; font-size: 1.5em"><strong>{{open_date}}</strong></p> -->
              <p style="margin-top: 15px; font-size: 1.5em">
                <strong v-if="is_nf === true">{{open_special_date}}</strong>
                <strong v-if="is_nf === false">{{open_date}}</strong>
              </p>
              <p style="margin-top: 15px">Silakan akses kembali <strong>fitur pembahasan</strong> saat periode tryout telah berakhir</p>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-btn depressed block round large @click="dialog = false">Tutup</v-btn>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped>
.group-description__detail--spacy {
  margin-left: 8px;
  margin-right: 24px;
}

.group-description__tag--dark {
  color: #ffffff;
  font-weight: bold;
  padding: 5px 15px;
  background-color: #555555;
  border-radius: 10px !important;
  -moz-border-radius: 10px !important;
  -webkit-border-radius: 10px !important;
}
</style>

<script>
import moment from 'moment/src/moment'

export default {
  name: 'tryout-result-status',
  props: {
    data: {
      type: Object,
      required: true
    },
    discussion_opened: {
      type: Number,
      required: true
    },
    is_nf: {
      type: Boolean,
      required: false
    },
    discussion_special: {
      type: Number,
      required: true
    }
  },
  data: function () {
    return {
      dialog: false,
      open_date: null,
      open_special_date: null
    }
  },
  filters: {
    splitWord (value) {
      var getType = value.split('_')
      return getType[2]
    }
  },
  methods: {
    onLihatPembahasanClicked: function () {
      var now = moment().valueOf()
      var end = moment(this.discussion_opened).valueOf()
      var special = moment(this.discussion_special).valueOf()

      var localTime = moment.utc(this.discussion_opened).toDate()
      localTime = moment(localTime).format('YYYY-MM-DD HH:mm:ss')
      var tms = moment(localTime).format('DD MMMM YYYY HH:mm:ss')

      var localTimeSpec = moment.utc(this.discussion_special).toDate()
      localTimeSpec = moment(localTimeSpec).format('YYYY-MM-DD HH:mm:ss')
      var tmsSpec = moment(localTimeSpec).format('DD MMMM YYYY HH:mm:ss')

      this.open_date = tms
      this.open_special_date = tmsSpec

      var diff = end - now
      var diffSpec = special - now

      var groupId = this.$route.params.id

      // if (diff > 0) this.dialog = true
      // else this.$router.push({ path: '/result/' + groupId + '/pembahasan/' + this.data.id })
      var nf = JSON.parse(sessionStorage.profile)
      this.is_nf = nf.is_nf_student

      if (this.is_nf) {
        if (diffSpec > 0) this.dialog = true
        else this.$router.push({ path: '/result/' + groupId + '/pembahasan/' + this.data.id })
      } else {
        if (diff > 0) this.dialog = true
        else this.$router.push({ path: '/result/' + groupId + '/pembahasan/' + this.data.id })
      }
    }
  }
}
</script>
